import React, {useState} from 'react'
import * as a from '../' // Add the correct import path for 'a'

type Props = {
  className?: string
  compact?: boolean
  containerClassName?: string
  decimalPlaces?: number
  disabled?: boolean
  displayText?: string
  errorPlaceholder?: boolean
  errors?: any
  fieldName: any
  forceUserEntry?: boolean
  formik: any
  returnNumericValue?: boolean
  setTouchedField?: boolean
  touched?: any
  verticalLabel?: boolean
  width?: string
  comparisonValue?: any
  comparisonEntryMode?: any
  useCommas?: boolean
}

export const AncientInputNumeric = ({
  className,
  compact,
  containerClassName,
  decimalPlaces,
  disabled,
  displayText,
  errorPlaceholder,
  errors,
  fieldName,
  forceUserEntry,
  formik,
  returnNumericValue,
  setTouchedField,
  touched,
  verticalLabel,
  width,
  comparisonValue,
                                      comparisonEntryMode,
  useCommas = true
}: Props) => {
  const [isEditing, setIsEditing] = useState(false)


  const ENTRY_MODE = {
    EnterValue: 0,
    NotApplicable: 1,
    CurrentValue: 2
  }
  const formatValueWithCommas = () => {
    if (formik.getFieldProps(fieldName).value) {
      const numericValue = formik.getFieldProps(fieldName).value.toString()
      if (!useCommas) {
        return numericValue
      }

      const [integerValue, decimalValue] = numericValue.split('.')
      const formattedIntegerValue = integerValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return decimalValue === undefined
        ? formattedIntegerValue
        : `${formattedIntegerValue}.${decimalValue}`
    }
    return formik.getFieldProps(fieldName).value
  }

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const inputValue = event.currentTarget.value

    let regex
    if (decimalPlaces && decimalPlaces > 0) {
      regex = new RegExp(
        `^[-]?((\\d*(\\.\\d{0,${decimalPlaces}})?)|(\\d*,\\d{0,${decimalPlaces}}))$`
      )
    } else {
      // When decimalPlaces is null or 0, disallow decimal points entirely
      regex = /^[-]?\d*$/
    }

    // Check if the input value is numeric
    if (regex.test(inputValue)) {
      // Remove commas from the input value before updating the state
      let valueToUpdate: string | number = inputValue.replace(/,/g, '')

      if (returnNumericValue) {
        // If the returnNumericValue prop is set to true, return the numeric value
        if (valueToUpdate !== undefined && valueToUpdate !== '-') {
          valueToUpdate = Number(valueToUpdate)
        }
        formik.setFieldValue(fieldName, valueToUpdate)
      } else {
        // Update the input value with the numeric value without commas
        formik.setFieldValue(fieldName, valueToUpdate)
        // formik.setFieldProps(fieldName).onChange(numericValue);
      }

      // Update the component state to trigger re-render with the new value
      setIsEditing(true)
    } else {
      // If the input value is not numeric, revert to the previous value
      setIsEditing(false)
    }
  }

  const handleBlur = (event: React.FormEvent<HTMLInputElement>) => {
    if (forceUserEntry != false && formik.getFieldProps(fieldName).value == '') {
      formik.setFieldValue(fieldName, 0)
    }
    if (setTouchedField) {
      formik.setFieldTouched(fieldName, true)
    }
    setIsEditing(false)
  }

  return (
    <>
      {formik.getFieldProps(fieldName) == undefined ? (
        <></>
      ) : (
        <>
          {verticalLabel ? (
            <a.AncientFormWrapVertical displayText={displayText} className={containerClassName}>
              <input
                type='text'
                className={
                  'form-control mb-3 mb-lg-0 ' +
                  (compact ? 'form-control-sm' : 'form-control-lg') +
                  (className && ` ${className}`)
                }
                style={{width: width != undefined ? width : 0}}
                placeholder={displayText}
                disabled={disabled}
                value={isEditing ? formik.values[fieldName] || '' : formatValueWithCommas()}
                onInput={handleInput}
                onFocus={() => setIsEditing(true)}
                onBlur={handleBlur}
              />
              {errors != undefined ? (
                <div className='fv-plugins-message-container' style={{fontSize: '12px'}}>
                  <div className='fv-help-block'>{errors}</div>
                </div>
              ) : (
                <></>
              )}
            </a.AncientFormWrapVertical>
          ) : (
            <a.AncientFormWrapHorizontal displayText={displayText} className={containerClassName}>
              <input
                type='text'
                className={
                  'form-control mb-3 mb-lg-0 ' + (compact ? 'form-control-sm' : 'form-control-lg')
                }
                style={{width: width != undefined ? width : 0}}
                placeholder={displayText}
                disabled={disabled}
                value={
                  isEditing ? formik.getFieldProps(fieldName).value || '' : formatValueWithCommas()
                }
                onInput={handleInput}
                onFocus={() => setIsEditing(true)}
                onBlur={handleBlur}
              />
              {comparisonValue && (<i>Current Value: {comparisonValue}</i>)}
              {comparisonEntryMode == ENTRY_MODE.NotApplicable && (<i>Current Value: N/A</i>)}
              
              {errors != undefined ? (
                <div className='fv-plugins-message-container' style={{fontSize: '12px'}}>
                  <div className='fv-help-block'>{errors}</div>
                </div>
              ) : (
                <></>
              )}
            </a.AncientFormWrapHorizontal>
          )}
        </>
      )}
    </>
  )
}
